import type { Grinder } from "./model";

/**
 * Number formatting that matches Java's String.format("%.Nf") for the positive values we print.
 * Both JS toFixed and Java's Formatter round the exact binary value half-up for positive numbers.
 */
export function decimalsFor(resolution: number): number {
  let dp = 0;
  let r = resolution;
  while (dp < 4 && Math.abs(r - Math.round(r)) > 1e-9) {
    r *= 10;
    dp++;
  }
  return dp;
}

/** Dial value with as many decimals as the resolution needs (0.1 → "7.4", 0.25 → "7.25"). */
export function formatDial(x: number, g: Grinder): string {
  return x.toFixed(decimalsFor(g.dialResolution));
}

export function formatSeconds(s: number): string {
  return s.toFixed(1);
}
